import React, { createContext, useContext } from 'react';

import { AssessmentViewModel } from '@/api';
import { globalEnums } from '@/shared/duck';

interface AssessmentsContextProps {
  viewType: globalEnums.EAssessmentsViewType;
  setViewType: (type: globalEnums.EAssessmentsViewType) => void;
  selectedAssessment: AssessmentViewModel | undefined;
  setSelectedAssessment: React.Dispatch<React.SetStateAction<AssessmentViewModel | undefined>>;
}

export const AssessmentsContext = createContext<AssessmentsContextProps | undefined>(undefined)

export const useAssessmentsContext = (): AssessmentsContextProps => {
  const context = useContext(AssessmentsContext);
  if (!context) {
    throw new Error('useAssessmentsContext must be used within a AssessmentsProvider');
  }
  return context;
}